import { useEffect, useRef } from 'react';

// calls `onEscape` when Escape is pressed; the document listener only exists while `active`
export const useEscapeKey = (active: boolean, onEscape: () => void) => {
    const onEscapeRef = useRef(onEscape);
    onEscapeRef.current = onEscape;

    useEffect(() => {
        if (!active) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') onEscapeRef.current();
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [active]);
};
